<template>
    <transition name="fade">
        <div class="ad_mask">
            <span @click="$emit('done')">跳过<a class="cs">{{times}}</a>秒</span>
        </div>
    </transition>
</template>
<script type="text/javascript">
export default {
    props: {
        timer: {
            type: Number,
            default: 3
        }
    },
    data () {
        return {
            times: 0
        }
    },
    mounted () {
        this.times = this.timer
        this.si = setInterval(() => {
            if (this.times > 0) {
                this.times--
            } else {
                clearInterval(this.si)
                this.$emit('done')
            }
        }, 1000)
    }
}
</script>
<style lang="less">
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
.ad_mask {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 10002;
    background: url(../assets/images/kpgg.png) no-repeat top #fff;
    background-size: 100%;
    span {
        position: fixed;
        top: 10px;
        right: 10px;
        padding: 10px;
        text-align: right;
        color: #fff;
        font-size: 15px;
    }
    a {
        display: inline-block;
        width: 15px;
        text-align: center;
        color: #ffc306;
    }
}
</style>
